import React from "react";
import PricingArea from "../../components/Pricing/PricingArea";
import Layout from "../../layouts/Layout";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import NewsLetterArea from "../../components/NewsLetter/NewsLetterArea";
import DocumentMeta from "react-document-meta";
import { Helmet } from "react-helmet";

function Pricing() {
  return (
    <>
      <Helmet>
        <title>Pricing – The Digital Creative Designs USA</title>
        <meta
          name="description"
          content="The Digital Creative Designs delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="author" content="The Digital Creative Designs" />
        <meta property="og:title" content="Pricing – The Digital Creative Designs USA" />
        <meta
          property="og:description"
          content="The Digital Creative Designs delivers innovative graphic design solutions that elevate your brand. Discover how our expert team can bring your vision to life. Contact us today!"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AU" />
        <meta property="og:site_name" content="The Digital Creative Designs US" />
        <meta property="og:url" content="https://thedigitalcreativedesigns.com/pricing" />
        <meta
          property="og:image"
          content="https://thedigitalcreativedesigns.com/img/logo1.png"
        />
        <link rel="canonical" href="https://thedigitalcreativedesigns.com/pricing" />
      </Helmet>
      <Layout header={1} footer={1} className="" mainClassName="">
        <BreadcrumbArea
          title={"Pricing"}
          subtitle={"Our pricing plan"}
          className={"breadcrumb-area-two pt-175"}
          showShape={false}
        />
        <PricingArea />
        <NewsLetterArea />
      </Layout>
    </>
  );
}

export default Pricing;
